import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeWkblSpecialVideoAsc,
  changeWkblSpecialVideoPage,
  changeWkblSpecialVideoReturnCount,
  changeWkblSpecialVideoSort,
  clearWkblSpecialVideoList,
  requestWkblSpecialVideoList,
} from 'redux/actions/actions';
import { RootState } from 'redux/reducers/type';
import WkblVideoParamVO from 'commons/vo/param/WkblVideoParamVO';
import { SortType, AscType } from 'commons/constants/type';

function useWkblSpecialVideo() {
  const dispatch = useDispatch();

  const onRequestWkblSepcialVideoList = useCallback(
    (param: WkblVideoParamVO) => {
      dispatch(requestWkblSpecialVideoList({ param }));
    },
    [dispatch],
  );

  const onClearWkblSpecialVideoList = useCallback(() => {
    dispatch(clearWkblSpecialVideoList());
  }, [dispatch]);

  const onChangeWkblSpecialVideoPage = useCallback(
    (pageNumber: number) => {
      dispatch(changeWkblSpecialVideoPage({ pageNumber }));
    },
    [dispatch],
  );

  const onChangeWkblSpecialVideoSort = useCallback(
    (sort: SortType) => {
      dispatch(changeWkblSpecialVideoSort({ sort }));
    },
    [dispatch],
  );
  const onChangeWkblSpecialVideoAsc = useCallback(
    (asc: AscType) => {
      dispatch(changeWkblSpecialVideoAsc({ asc }));
    },
    [dispatch],
  );

  const onChangeWkblSpecialVideoReturnCount = useCallback(
    (returnCount: number) => {
      dispatch(changeWkblSpecialVideoReturnCount({ returnCount }));
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      onRequestWkblSepcialVideoList,
      onClearWkblSpecialVideoList,
      onChangeWkblSpecialVideoPage,
      onChangeWkblSpecialVideoAsc,
      onChangeWkblSpecialVideoReturnCount,
      onChangeWkblSpecialVideoSort,
    }),
    [
      onRequestWkblSepcialVideoList,
      onClearWkblSpecialVideoList,
      onChangeWkblSpecialVideoPage,
      onChangeWkblSpecialVideoAsc,
      onChangeWkblSpecialVideoReturnCount,
      onChangeWkblSpecialVideoSort,
    ],
  );
}

export default useWkblSpecialVideo;
